import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Carolina Bahamondes',
  location: 'Sierra Nevada · 2024',
  quote: 'No sabía cuánto necesitaba este viaje hasta que lo viví. Me voy distinta, más tranquila, más conectada conmigo y con mujeres increíbles.'
}, {
  name: 'Jocelyn Jaramillo',
  location: 'Conguillío · 2024',
  quote: 'Llegué sola... y me voy con amigas, recuerdos y una versión de mí que no veía hace mucho tiempo.'
}, {
  name: 'Florencia Pavez',
  location: 'Riviera Maya · 2025',
  quote: 'Una experiencia transformadora. Volví a casa con una nueva versión de mí y un grupo de amigas para toda la vida.'
}];
export function TestimonialsSection() {
  return <section className="relative py-32 md:py-40 px-6 md:px-12 lg:px-24 flex items-center justify-center overflow-hidden" data-id="element-170">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1544550581-5f7ceaf7f992?q=80&w=2000&auto=format&fit=crop")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-171">
        <div className="absolute inset-0 bg-charcoal/70 mix-blend-multiply" data-id="element-172" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full" data-id="element-173">
        {/* Eyebrow & Divider */}
        <div className="mb-16 md:mb-24 text-center" data-id="element-174">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-white/60 block mb-4" data-id="element-175">
            — 03 / TESTIMONIOS
          </span>
          <div className="w-24 h-[1px] bg-white/20 mx-auto mb-12" data-id="element-176" />

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif italic text-white leading-[1.1]" data-id="element-177">
            Lo que viven
            <br data-id="element-178" />
            nuestras <span className="font-bold" data-id="element-179">Aventureras</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-180">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx * 0.2
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-10 rounded-2xl text-white flex flex-col h-full relative" data-id="element-181">
              <Quote className="w-8 h-8 text-rose-primary/80 absolute top-8 right-8" data-id="element-182" />

              <div className="flex space-x-1 mb-8" data-id="element-183">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-rose-primary text-rose-primary" data-id="element-184" />)}
              </div>

              <p className="font-sans font-light text-sm md:text-base leading-relaxed mb-10 flex-grow text-white/90" data-id="element-185">
                "{test.quote}"
              </p>

              <div data-id="element-186">
                <p className="font-serif italic text-lg text-white mb-1" data-id="element-187">
                  {test.name}
                </p>
                <p className="font-sans text-xs uppercase tracking-wider text-white/50" data-id="element-188">
                  {test.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}